module.exports = __webpack_public_path__ + "static/media/img-left.a58bfbb1.png";